export default __webpack_public_path__ + "static/media/icons8-print-96.e24f5c23.svg";